import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../Contexts/AppContext";

const ComingSoon = () => {
  const context = useContext(AppContext);
  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [currentColor, setCurrentColor] = useState("");
  useEffect(() => {
    localStorage.setItem("current", "default");
    context.setCurrent("default");
    setCurrentBG(
      context.isLight
        ? context.currentTheme["default"].bg
        : context.currentTheme["default"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["default"].text
        : context.currentTheme["default"].dark_text
    );
    setCurrentColor(
      context.isLight
        ? context.currentTheme["default"].dark_dropdown
        : context.currentTheme["default"].dropdown
    );
  }, [context]);

  return (
    <div
      className="flex min-h-[calc(100vh-56px)] w-screen flex-col items-center justify-center transition-all duration-500"
      style={{ backgroundColor: currentBG, color: currentText }}
    >
      <div>
        <h1 className="logo-font text-5xl font-bold">COMING SOON</h1>
        <p className="mt-2 ml-5 text-xl font-thin">Stay Tune</p>
      </div>
    </div>
  );
};

export default ComingSoon;
